'use client'

import { useLocation } from '@tanstack/react-router'

// Drop-in for next/navigation's usePathname. Wraps TanStack Router's
// `useLocation({ select })` so callers don't need to know the selector idiom.
export function usePathname(): string {
  return useLocation({ select: (l) => l.pathname })
}
